// Shared container width — mirrors the Figma breakpoint spec:
//   ≥ 1200px  →  1136px  (standard laptop)
//   ≥ 1700px  →  1600px  (ultra-wide desktop)
//
// Usage:
//   import { CONTAINER_SX } from '../../style/containers';
//   <Container maxWidth={false} sx={CONTAINER_SX}>

export const CONTAINER_SX = {
  width: '100%',
  mx: 'auto',
  maxWidth: '1920px',
  px: {
    xs: 2,
    sm: 4,
    md: '5.5vw',
    lg: '7vw',
    xl: '8.33%',
  },
};
